import styled from "styled-components";
import Datepicker from "./Datepicker";

export const SearchHalfDatePicker = styled(Datepicker)`
  width: 135px;
  height: 32px;
`